import React from "react"
import './progress.css'

export const CPProgress = ({ className = "", registros = [] }) => {

    return (
        <table className="table_progress">
            <thead>
                <tr>
                    <th style={{ width: '50px', textAlign: 'left' }}></th>
                    <th></th>
                    <th style={{ width: '150px' }}></th>
                    <th style={{ width: '100px',textAlign:'right' }}></th>
                </tr>
            </thead>
            <tbody>
                {
                    registros.map((registro, i) =>
                        <tr key={i}>
                            <td>{registro.PORCENTAJE}</td>
                            <td><progress className="progreso" max="100" value={registro.PORCENTAJE}></progress></td>
                            <td>{registro.DESCRIPCION}</td>
                            <td>{registro.TOTAL}</td>
                        </tr>
                    )
                }
            </tbody>
        </table>

    );
}